import * as React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Button, TextField, Theme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    width: '100%',
    padding: theme.spacing(5),
  },
  formItem: {
    minHeight: 120,
    [theme.breakpoints.down('lg')]: {
      minHeight: 'unset',
    },
  },
  button: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  chip: {
    margin: theme.spacing(0.5, 0.5, 0.5, 0),
  },
}));

type Props = {
  onSubmit: (data: ProductgroupFormDto) => void;
  onCancel?: () => void;
  cancelButton?: boolean;
  defaultValues?: ProductgroupFormDto;
  buttonText: string;
  loading: boolean;
};

const ProductgroupForm: React.FC<Props> = ({
  onSubmit,
  onCancel = () => null,
  defaultValues = {
    name: '',
  },
  buttonText,
  cancelButton = false,
  loading,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { register, handleSubmit, formState: { errors } } = useForm<ProductgroupFormDto>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues,
  });

  const requiredMessage = t('validation:required');
  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid size={{ lg: 4, xs: 12}} className={classes.formItem}>
          <TextField
            {...register('name', {
              required: requiredMessage,
            })}
            autoComplete="off"
            fullWidth
            variant="outlined"
            color="secondary"
            margin="normal"
            id="name"
            label={t('name')}
            autoFocus
            error={!!errors.name}
            helperText={errors.name?.message}
          />
        </Grid>
        <Grid size={{lg: 6, xs: 10}} container direction="row">
          {cancelButton && (
            <Button
              variant="contained"
              color="secondary"
              classes={{ root: classes.button }}
              onClick={onCancel}
            >
              {t('common:cancel')}
            </Button>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            classes={{ root: classes.button }}
            disabled={loading}
          >
            {buttonText}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ProductgroupForm;
